import { Reveal, Overline } from "@/components/Reveal";

const chapters = [
  "Keine trockene Paragraphensammlung.",
  "Kein unnötiger Juristensprech.",
  "Sondern Orientierung für die Praxis.",
];

const Positioning = () => (
  <section
    data-testid="positioning-section"
    className="relative py-24 sm:py-32 bg-navy-900 border-y border-white/5 overflow-hidden"
  >
    <div
      aria-hidden="true"
      className="absolute -bottom-48 left-1/3 h-[520px] w-[520px] rounded-full bg-[radial-gradient(circle,rgba(0,102,255,0.12)_0%,rgba(13,20,36,0)_70%)]"
    />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Overline>Positionierung</Overline>

      <div className="mt-8 space-y-3">
        {chapters.map((c, i) => (
          <Reveal key={c} delay={i * 0.15} y={40}>
            <h3
              data-testid={`positioning-chapter-${i + 1}`}
              className={`font-display font-extrabold tracking-tight text-2xl sm:text-4xl lg:text-5xl leading-tight ${
                i === 2 ? "text-blau text-glow-blue" : "text-white"
              }`}
            >
              {c}
            </h3>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-12 max-w-3xl text-base md:text-lg text-gray-400 leading-relaxed">
          Statt abstrakte Vorschriften isoliert zu betrachten, bringt das Buch
          Datenschutzfragen in den praktischen Zusammenhang von
          Einsatzorganisationen. Klare Strukturen, verständliche Erläuterungen
          und konkrete Beispiele helfen dabei, Risiken zu erkennen und die
          richtigen Fragen zu stellen.
        </p>
        <p className="mt-8 max-w-3xl border-l-2 border-blau pl-6 text-lg sm:text-xl font-semibold text-white">
          So entsteht aus einem vermeintlich komplizierten Thema ein
          nachvollziehbares System.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Positioning;
